import { render, staticRenderFns } from "./studentHomepage.vue?vue&type=template&id=489635f7&scoped=true"
import script from "./studentHomepage.vue?vue&type=script&lang=js"
export * from "./studentHomepage.vue?vue&type=script&lang=js"
import style0 from "./studentHomepage.vue?vue&type=style&index=0&id=489635f7&prod&scoped=true&lang=css"
import style1 from "./studentHomepage.vue?vue&type=style&index=1&id=489635f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489635f7",
  null
  
)

export default component.exports